// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Cart_wrapper__1ss0X","total":"Cart_total__1Xv4r","btnWrapper":"Cart_btnWrapper__1XIBJ","checkoutBtn":"Cart_checkoutBtn__2fwv6","resultsBtn":"Cart_resultsBtn__7bCc1"};